import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useApi, useMe, fmtDate } from "@/lib/api";
import { PageTitle } from "@/components/Bits";

const H = ({ children }) => <TableHead className="font-mono text-[10px] tracking-[0.2em] uppercase">{children}</TableHead>;

export default function AdminUsers() {
  const api = useApi();
  const { me } = useMe();
  const [data, setData] = useState({ roles: [], users: [] });
  const load = () => api("get", "/users").then(setData);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [api]);

  const changeRole = async (uid, role) => {
    try { await api("patch", `/users/${uid}/role`, { role }); toast.success("Role updated"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Could not change role"); }
  };

  return (
    <div className="fade-up" data-testid="admin-users-page">
      <PageTitle kicker="Super admin" title="Travellers" />
      <div className="border border-slate-800 overflow-x-auto">
        <Table>
          <TableHeader><TableRow className="border-slate-800 hover:bg-transparent">
            <H>User</H><H>Joined</H><H>Assessments</H><H>Passed</H><H>Failed</H><H>Avg</H><H>Last session</H><H>Role</H><H> </H>
          </TableRow></TableHeader>
          <TableBody>
            {data.users.map((u) => (
              <TableRow key={u.user_id} className="border-slate-800" data-testid={`user-row-${u.user_id}`}>
                <TableCell><div className="text-white text-sm">{u.name}</div><div className="font-mono text-[11px] text-slate-500">{u.email}</div></TableCell>
                <TableCell className="font-mono text-xs text-slate-400">{fmtDate(u.created_at)}</TableCell>
                <TableCell className="font-cabinet font-bold text-white">{u.stats.total}</TableCell>
                <TableCell className="text-emerald-500 font-bold">{u.stats.passed}</TableCell>
                <TableCell className="text-rose-500 font-bold">{u.stats.failed}</TableCell>
                <TableCell className="text-white">{u.stats.average_score}</TableCell>
                <TableCell className="font-mono text-xs text-slate-400">{fmtDate(u.last_session)}</TableCell>
                <TableCell>
                  <Select value={u.role} onValueChange={(r) => changeRole(u.user_id, r)} disabled={u.user_id === me?.user_id}>
                    <SelectTrigger className="w-28 h-8 bg-slate-900 border-slate-800" data-testid={`user-role-select-${u.user_id}`}><SelectValue /></SelectTrigger>
                    <SelectContent className="bg-slate-900 border-slate-800">{data.roles.map((r) => <SelectItem key={r} value={r}>{r}</SelectItem>)}</SelectContent>
                  </Select>
                </TableCell>
                <TableCell><Link to={`/admin/sessions?user=${u.user_id}`} className="text-xs text-blue-400 hover:text-blue-300 whitespace-nowrap" data-testid={`user-history-link-${u.user_id}`}>View history →</Link></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
